import { ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import s from './ShowMoreButton.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {

}

export const ShowMoreButton = ({ disabled, className, ...props }: Props) => {
  return (
    <button
      className={clsx(s.button, className, { [s.button__disabled]: disabled })}
      {...props}
    >
      Показать ещё
    </button>
  );
};